// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.talousarvio {
  width: 100%;
  margin-bottom: 2rem;
}
.talousarvio_header {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.talousarvio_header-column {
  width: 160px;
  padding: 0 0.5rem;
  text-align: end;
}
.talousarvio_rows {
  width: 100%;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.talousarvio_rows .meno-row,
.talousarvio_rows .summary-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.talousarvio_rows .meno-row .meno-description,
.talousarvio_rows .summary-row .meno-description {
  flex-grow: 1;
  padding: 0.5rem;
}
.talousarvio_rows .meno-row .meno-amount,
.talousarvio_rows .summary-row .meno-amount {
  flex-grow: 0;
  flex-shrink: 0;
  text-align: end;
  padding: 0.5rem;
  width: 160px;
}
.talousarvio_rows .meno-row .meno-amount--linethrough,
.talousarvio_rows .summary-row .meno-amount--linethrough {
  text-decoration: line-through;
}
.talousarvio_rows .meno-row .meno-amount:not(:last-of-type),
.talousarvio_rows .summary-row .meno-amount:not(:last-of-type) {
  border-right: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.talousarvio_rows .meno-row-even {
  background: #fafafa;
}
.talousarvio .meno-row:last-of-type {
  border-top: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.muutoshakemus_talousarvio .headerContainer {
  display: flex;
  margin-bottom: 20px;
}
.muutoshakemus_talousarvio .headerContainer .currentBudget {
  width: 371px;
}
.muutoshakemus_talousarvio_horizontalSeparator {
  background-color: #98918f;
  border: 0;
  height: 1px;
  width: 506px;
  margin: 19px auto 0 0;
}
.muutoshakemus_talousarvio_horizontalSeparatorWithRequestedAmount {
  background-color: #98918f;
  border: 0;
  height: 1px;
  width: 576px;
  margin: 19px auto 0 0;
}
.muutoshakemus_talousarvio_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 38px;
}
.muutoshakemus_talousarvio_row .currentBudget {
  display: flex;
  justify-content: space-between;
  width: 300px;
}
.muutoshakemus_talousarvio_row .description {
  width: 240px;
}
.muutoshakemus_talousarvio_row .requestedHeader {
  width: 80px;
  margin-right: 30px;
}
.muutoshakemus_talousarvio_row .requestedAmount {
  width: 80px;
  margin-right: 30px;
  text-align: right;
}
.muutoshakemus_talousarvio_row .existingAmount {
  width: 100px;
  text-align: right;
}
.muutoshakemus_talousarvio_row .linethrough {
  text-decoration: line-through;
}
.muutoshakemus_talousarvio_row .uppercase {
  text-decoration: uppercase;
}
.muutoshakemus_talousarvio_row .separator {
  align-self: stretch;
  margin-left: 17px;
  border-right: 1px solid #98918f;
  margin-right: 13px;
}
.muutoshakemus_talousarvio_row .noborder {
  border: 0;
}
.muutoshakemus_talousarvio_row .changedAmount {
  width: 120px;
  display: flex;
  align-items: center;
  overflow: visible;
  white-space: nowrap;
}
.muutoshakemus_talousarvio_row .changedAmount input {
  width: 100px;
  margin-right: 5px;
}
.muutoshakemus_talousarvio_row .changedAmountEur {
  width: 15px;
}
.muutoshakemus_talousarvio_row .currentSumError {
  color: #c9302c;
}
#hakemus-arviointi [class="muutoshakemus_talousarvio"][data-accepted="true"] .linethrough {
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./soresu-form/web/va/muutoshakemus/talous.less"],"names":[],"mappings":"AAIA;EACE,WAAA;EACA,mBAAA;AAHF;AAKE;EACE,aAAA;EACA,yBAAA;EACA,WAAA;AAHJ;AAKI;EACE,YAAA;EACA,iBAAA;EACA,eAAA;AAHN;AAOE;EACE,WAAA;EACA,yBAAA;EACA,sBAAA;AALJ;AAEE;;EAOI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AALN;AALE;;EAaM,YAAA;EACA,eAAA;AAJR;AAVE;;EAkBM,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AAJR;AAMQ;;EACE,6BAAA;AAHV;AAtBE;;EA8BM,+BAAA;EACA,sBAAA;AAJR;AA3BE;EAoCI,mBAAA;AANN;AA9CA;EAyDI,6BAAA;EACA,sBAAA;AARJ;AAiCA;EAEI,aAAA;EACA,mBAAA;AAhCJ;AA6BA;EAMM,YAAA;AAhCN;AAoCE;EACE,yBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AAlCJ;AAqCE;EACE,yBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AAnCJ;AAsCE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AApCJ;AAgCE;EAOI,aAAA;EACA,8BAAA;EACA,YAAA;AApCN;AA2BE;EAaI,YAAA;AArCN;AAwBE;EAiBI,WAAA;EACA,kBAAA;AAtCN;AAoBE;EAsBI,WAAA;EACA,kBAAA;EACA,iBAAA;AAvCN;AAeE;EA4BI,YAAA;EACA,iBAAA;AAxCN;AAWE;EAiCI,6BAAA;AAzCN;AAQE;EAqCI,0BAAA;AA1CN;AAKE;EAyCI,mBAAA;EACA,iBAAA;EACA,+BAAA;EACA,kBAAA;AA3CN;AADE;EAgDI,SAAA;AA5CN;AAJE;EAoDI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AA7CN;AAXE;EA2DM,YAAA;EACA,iBAAA;AA7CR;AAfE;EAiEI,WAAA;AA/CN;AAlBE;EAqEI,cAAA;AAhDN;AAqDA;EAGE,qBAAA;AArDF","sourcesContent":["@import \"~soresu-form/web/form/style/variables.less\";\n\n@amount-column-width: 160px;\n\n.talousarvio {\n  width: 100%;\n  margin-bottom: 2rem;\n\n  &_header {\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n\n    &-column {\n      width: @amount-column-width;\n      padding: 0 0.5rem;\n      text-align: end;\n    }\n  }\n\n  &_rows {\n    width: 100%;\n    border: 1px solid @light-gray;\n    box-sizing: border-box;\n\n    .meno-row,\n    .summary-row {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      width: 100%;\n\n      .meno-description {\n        flex-grow: 1;\n        padding: 0.5rem;\n      }\n\n      .meno-amount {\n        flex-grow: 0;\n        flex-shrink: 0;\n        text-align: end;\n        padding: 0.5rem;\n        width: @amount-column-width;\n\n        &--linethrough {\n          text-decoration: line-through;\n        }\n      }\n\n      .meno-amount:not(:last-of-type) {\n        border-right: 1px solid @light-gray;\n        box-sizing: border-box;\n      }\n    }\n\n    .meno-row-even {\n      background: @lightest-gray;\n    }\n  }\n\n  .meno-row:last-of-type {\n    border-top: 1px solid @light-gray;\n    box-sizing: border-box;\n  }\n}\n\n@currentBudgetWidth: 300px;\n@descriptionWidth: 240px;\n@existingAmountWidth: 100px;\n@requestedAmountWidth: 80px;\n@requestedAmountMargin: 30px;\n\n@separatorLeftMargin: 17px;\n@separatorBorder: 1px;\n@separatorRightMargin: 13px;\n@separatorWidth: @separatorLeftMargin + @separatorBorder + @separatorRightMargin;\n\n@leftColumnWidth: @descriptionWidth + @existingAmountWidth + @separatorWidth;\n\n@changedAmountWidth: 120px;\n@eurWidth: 15px;\n\n@totalWidth: @leftColumnWidth + @changedAmountWidth + @eurWidth;\n@totalWithRequestedAmountWidth: @currentBudgetWidth + @separatorWidth +\n  @requestedAmountWidth + @requestedAmountMargin + @changedAmountWidth +\n  @eurWidth;\n\n.muutoshakemus_talousarvio {\n  .headerContainer {\n    display: flex;\n    margin-bottom: 20px;\n\n    .currentBudget {\n      width: @leftColumnWidth;\n    }\n  }\n\n  &_horizontalSeparator {\n    background-color: @darkish-gray;\n    border: 0;\n    height: @separatorBorder;\n    width: @totalWidth;\n    margin: 19px auto 0 0;\n  }\n\n  &_horizontalSeparatorWithRequestedAmount {\n    background-color: @darkish-gray;\n    border: 0;\n    height: @separatorBorder;\n    width: @totalWithRequestedAmountWidth;\n    margin: 19px auto 0 0;\n  }\n\n  &_row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    min-height: 38px;\n\n    .currentBudget {\n      display: flex;\n      justify-content: space-between;\n      width: @currentBudgetWidth;\n    }\n\n    .description {\n      width: @descriptionWidth;\n    }\n\n    .requestedHeader {\n      width: @requestedAmountWidth;\n      margin-right: @requestedAmountMargin;\n    }\n\n    .requestedAmount {\n      width: @requestedAmountWidth;\n      margin-right: @requestedAmountMargin;\n      text-align: right;\n    }\n\n    .existingAmount {\n      width: @existingAmountWidth;\n      text-align: right;\n    }\n\n    .linethrough {\n      text-decoration: line-through;\n    }\n\n    .uppercase {\n      text-decoration: uppercase;\n    }\n\n    .separator {\n      align-self: stretch;\n      margin-left: @separatorLeftMargin;\n      border-right: @separatorBorder solid @darkish-gray;\n      margin-right: @separatorRightMargin;\n    }\n\n    .noborder {\n      border: 0;\n    }\n\n    .changedAmount {\n      width: @changedAmountWidth;\n      display: flex;\n      align-items: center;\n      overflow: visible;\n      white-space: nowrap;\n\n      input {\n        width: 100px;\n        margin-right: 5px;\n      }\n    }\n\n    .changedAmountEur {\n      width: @eurWidth;\n    }\n\n    .currentSumError {\n      color: @bright-red;\n    }\n  }\n}\n\n#hakemus-arviointi\n  [class=\"muutoshakemus_talousarvio\"][data-accepted=\"true\"]\n  .linethrough {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
